import { render, staticRenderFns } from "./SickLeaveRequestByQueryId.vue?vue&type=template&id=5436f5e7&scoped=true&"
import script from "./SickLeaveRequestByQueryId.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveRequestByQueryId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436f5e7",
  null
  
)

export default component.exports